// tslint:disable:max-line-length
import * as React from 'react';
import {WithStyles, withStyles, Dialog, IconButton,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { MonthviewStyle } from '../monthView/monthview.style';
import CloseIcon from '@material-ui/icons/CloseRounded';
import BackIcon from "@material-ui/icons/ArrowBackIos";
import { DialogTop } from '@components/economy/DialogComponens';
import { ISchedule } from '@app-types/websocket/schedule.types';
import SCHEDULE_TYPES from '@constants/scheduleTypes';
import { ICalendarSetting } from '@app-types/websocket/user.types';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof MonthviewStyle> {
  open:boolean;
  close:() => void;
  schedule?:ISchedule;
  settings?:ICalendarSetting;
}

interface IState {
  slide: number; 
}

class CalendarHelp extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      slide: 1,
    };

  }

  public componentDidUpdate(prevProps:IProps) {
    if (prevProps.open !== this.props.open) {
      this.setState({slide:0})
    }
  }

  public render() {
    const {classes, open, close} = this.props;
  
    return (
      <Dialog
        open={ this.props.open}
        onClose={() => this.props.close()}
      >
        <DialogTop style={{paddingLeft:'12px'}}>
          <IconButton onClick={() => this.setState({slide:0})} style={this.state.slide===0?{pointerEvents:'none', display:'none'}:{}}>
            <BackIcon />
          </IconButton>
          <div className={classes.guideHeader}>{this.state.slide===0?tn.lang.helpSchedule:""}</div>
          <IconButton onClick={() => this.props.close()}>
            <CloseIcon />
          </IconButton>
        </DialogTop>
        <div style={{padding: '24px', paddingTop: 0}}>
            {this.renderSlide(this.state.slide)}
        </div>
      </Dialog>
    );
  }

  private renderSlide(slide:number):JSX.Element {
    const classes = this.props.classes;
    if (slide === 0) {
      return (<div style={{display: 'flex', flexDirection: 'column', gap:'12px'}}>
        <div onClick={() => this.setState({slide:1})} className={classes.guideButton}>        
          <div className={classes.guideLabel}>{tn.lang.helpScheuleIntoTopic}</div>
        </div>
        <div onClick={() => this.setState({slide:2})} className={classes.guideButton}>        
          <div className={classes.guideLabel}>{tn.lang.helpScheduleQuickTopic}</div>
        </div>
        <div onClick={() => this.setState({slide:3})} className={classes.guideButton}>        
          <div className={classes.guideLabel}>{tn.lang.helpScheduleTemplateTopic}</div>
        </div>
        <div onClick={() => this.setState({slide:4})} className={classes.guideButton}>        
          <div className={classes.guideLabel}>{tn.lang.helpScheduleTempPlaceTopic}</div>
        </div>
        <div onClick={() => this.setState({slide:5})} className={classes.guideButton}>        
          <div className={classes.guideLabel}>{tn.lang.helpScheduleMultiTopic}</div>
        </div>
      </div>);
    } else if (slide === 1) {
      return tn.lang.helpScheuleInto(tn.lang.scheduleNameNew(this.props.schedule), this.scheduleStatus());
    } else if (slide === 2) {
      return tn.lang.helpScheduleQuick;
    } else if (slide === 3) {
      return tn.lang.helpScheduleTemplate;
    } else if (slide === 4) {
      return tn.lang.helpScheduleTempPlace;
    } else if (slide === 5) {
      return tn.lang.helpScheduleMulti;
    } else {
      return (<div>{tn.lang.unknown}</div>);
    }
  }

  private scheduleStatus():string {
    if (this.props.schedule === undefined) {
      return tn.lang.unknown;
    } else {
      if (this.props.schedule.status === SCHEDULE_TYPES.WIP) {
        return tn.lang.calPrivate;
      } else if ((this.props.schedule.status === SCHEDULE_TYPES.SHARED || this.props.schedule.status === SCHEDULE_TYPES.ACTIVE) 
        && this.props.settings && this.props.settings.calendars && this.props.settings.calendars.includes(this.props.schedule.id)) {
          return tn.lang.calActive;
      } else if (this.props.schedule.status === SCHEDULE_TYPES.SHARED || this.props.schedule.status === SCHEDULE_TYPES.ACTIVE) {
        return tn.lang.calShared;
      } else {
        return tn.lang.erased;
      }
    }
    
  }
}

export default withStyles(MonthviewStyle)(CalendarHelp);



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/CalendarHelp.tsx